(function ($) {
    window.Project = window.Project || {};
    
    Project.carousel = function () {
        $('.faculty-carousel .swiper').each(function (index, element) {
            new Swiper(element, {
                slidesPerView: 3,
                centeredSlides: false,
                spaceBetween: 100,
                autoHeight: true,
                loop: true,
                navigation: {
                    nextEl: ".faculty-carousel .swiper-button-next",
                    prevEl: ".faculty-carousel .swiper-button-prev",
                },
                pagination: {
                    el: ".faculty-carousel .swiper-pagination",
                },
                breakpoints: {
                    576: {
                        slidesPerView: 2,
                        autoHeight: false
                    },
                    992: {
                        slidesPerView: 3,
                        autoHeight: false
                    }
                }
            });
        });

        var max = 0;
        $('.faculty-carousel img').each(function () {
            max = Math.max(max, $(this).height());
        });
        $('.faculty-carousel img').css('height', max);
    };

    $(document).ready(function () {
        Project.carousel();
    });

$(function () {
  var hash = window.location.hash;

  if (hash) {
    var $tabLink = $('[data-bs-target="' + hash + '"], a[href="' + hash + '"]').filter(':visible').first();

    if ($tabLink.length) {
      var tab = new bootstrap.Tab($tabLink[0]);
      tab.show();

      var $module = $tabLink.closest('.module, .tabs, .tab-module');

      setTimeout(function () {
        var $target = $module.length ? $module.find(hash) : $(hash);

        if (!$target || !$target.length) {
          $target = $(hash).first();
        }

        if ($target.length) {
          var offset = Math.max(0, $target.offset().top - 100);
          $('html, body').animate({ scrollTop: offset }, 500);
        }
      }, 120);
    }
  }

  $('[data-bs-toggle="pill"], [data-bs-toggle="tab"]').on('shown.bs.tab', function (e) {
    var $link = $(e.target);
    var target = $link.attr('data-bs-target') || $link.attr('href');
    if (!target) return;
    try {
      history.replaceState(null, null, target);
    } catch (err) {
      // IE fallback - do nothing
    }

    var $module = $link.closest('.module, .tabs, .tab-module');
    var $target = $module.length ? $module.find(target) : $(target);

    if (!$target || !$target.length) {
      $target = $(target).first();
    }

    if ($target.length) {
      var offset = Math.max(0, $target.offset().top - 100);
      $('html, body').animate({ scrollTop: offset }, 300);
    }
  });
});

})(jQuery);

(function ($) {
  if (!$('body').hasClass('page-id-31566')) {
    return;
  }
  const $header = $('.site-header');
  $(window).on('scroll', function () {
    const scrollTop = $(this).scrollTop();
    const height = $header.outerHeight();
    if (scrollTop <= 0) {
      $header.css('top', '0');
    } else {
      $header.css('top', `-${height}px`);
    }
  });
})(jQuery);


